import axios from "axios";
import {useQuery} from "react-query";
import {PowerStationDailyGeneration} from "../utils/DailyGenerationChart.utils";

export const DAILY_GENERATION_BY_POWER_STATION_URL = "api/generation-energy/power-stations/daily";
// Sem barra inicial: GATEWAY_URL já termina com "/" (com "//" o gateway responde 400).
export const DAILY_GENERATION_BY_POWER_STATION_CSV_URL = "api/generation-energy/csv/power-stations/daily";

// Spring espera powerStationIds repetido (powerStationIds=1&powerStationIds=2); o axios serializaria array como "[]".
export const buildDailyGenerationParams = (date: string, powerStationIds?: number[]): URLSearchParams => {
    const params = new URLSearchParams();
    params.append("date", date);
    (powerStationIds ?? []).forEach((id) => params.append("powerStationIds", String(id)));
    return params;
};

const fetchDailyGenerationByPowerStation = async (date: string, powerStationIds?: number[]): Promise<PowerStationDailyGeneration[]> => {
    const response = await axios.get(DAILY_GENERATION_BY_POWER_STATION_URL, {params: buildDailyGenerationParams(date, powerStationIds)});
    return response.data?.data ?? [];
};

// date no formato yyyy-MM-dd. Atualiza no mesmo intervalo dos demais cards da Visão Diária. SGD-3816.
// powerStationIds: undefined = todas as usinas do usuário; [] = nenhuma (não busca).
export const DailyGenerationByPowerStationReactQuery = (
    date: string,
    refetchInterval?: number,
    powerStationIds?: number[],
    enabled = true
) => {
    return useQuery(
        ["daily-generation-by-power-station", date, powerStationIds ?? "all"],
        () => fetchDailyGenerationByPowerStation(date, powerStationIds),
        {
            enabled: enabled && (powerStationIds === undefined || powerStationIds.length > 0),
            refetchInterval: refetchInterval && refetchInterval > 0 ? refetchInterval : false,
            retry: 2,
        }
    );
};
